import {createSelector} from 'reselect';
import {getFrom, compose} from '@pluto/utils';

export const selectContentItemViewMetadataDraft = createSelector(
    getFrom('contentItemView'),
    compose(getFrom('isDraft'), getFrom('contentItemViewMetadata'))
);
